import { useTranslation } from 'react-i18next';

/**
 * Shown inside the native macOS shell when the token injection never arrived
 * or the exchange failed. We deliberately do not fall back to the hosted login
 * page here: the shell owns authentication, and redirecting the WebView away
 * also destroys the `window.setAuthTokens` bridge.
 */
export const NativeAuthError: React.FC = () => {
  const { t } = useTranslation();

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen px-4 text-center">
      <p className="text-lg text-white mb-6">{t('auth.nativeAuthFailed')}</p>
      <button
        onClick={handleRetry}
        className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white rounded-lg font-medium transition-colors duration-200">
        {t('common.tryAgain')}
      </button>
    </div>
  );
};

export default NativeAuthError;
